export enum DevelopmentResposeEnumType { 
    Positive = "09F74D51-0F38-F011-8EF6-00155D112802",
    Negative = "F818A05A-0F38-F011-8EF6-00155D112802",
    UnCategorized = "b219948b-0aa7-ef11-8b5a-cc1531973717"
}

export const OtherCategoryId = 'ae460a7b-ed1a-4df9-b804-9d3b76952c6c';